import * as React from "react";
import { HStack } from "@chakra-ui/react";
import { PageHeader } from "components";
import * as LC from "./components";

const Title: React.FC = () => (
  <PageHeader
    title="Cases"
    actions={
      <HStack spacing="16px">
        <LC.Actions />
        <LC.Create />
      </HStack>
    }
  />
);

export default Title;
